import React from 'react'
import FilterTag from './FilterTag'
import {useStore} from '../Store/useStore'
import Search from './Search'

const Filters = ({className}) => {
    const isFilterLogicOr = useStore((state) => state.isFilterLogicOr)
    const availableFilters = useStore((state) => state.availableFilters)()
    const initiallyAvailableFilters = useStore((state) => state.initiallyAvailableFilters)()
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const currentSearchTerm = useStore((state) => state.currentSearchTerm)
    const resetFilterState = useStore((state) => state.resetFilterState)
    const translations = useStore((state) => state.translations)

    const getResetFilter = () => {
        if (activeFilterTagUids.length <= 0 && currentSearchTerm === '') {
            return null
        }

        return (
            <div className="journal-list__filter-group--reset">
                <a className="journal-list__filter-reset" onClick={() => resetFilterState()}>
                    <span aria-hidden="true">{translations.reset}</span>
                </a>
            </div>
        )
    }

    const getAvailableFilters = () => {
        if (isFilterLogicOr && currentSearchTerm === '') {
            return initiallyAvailableFilters
        } else {
            return availableFilters
        }
    }

    /**
     * This function is an easy workaround to remove "Creaton GmbH" from event location filters due to CCWP-833
     * @param categoryName
     * @param filter
     * @returns {*}
     */
    const removeCreatonStringFromEventLocationFilter = (categoryName, filter) => {
        if (categoryName === "Veranstaltungsort") {
            filter.name = filter.name.replace(/CREATON GmbH/gi, "");
        }
        return filter;
    }

    return (
        <div className="journal-list__filter-list">
            <Search/>
            <div className={className}>
                {getAvailableFilters().map((category, categoryIndex) => (
                    <div
                        className={
                            'journal-list__filter-group journal-list__filter-group--' + category.name.toLowerCase()
                        }
                        key={categoryIndex}
                    >
                        <div
                            className="journal-list__filter-group--header">{category.name === 'Date' ? translations.date : category.name}</div>
                        {category.tags.map((filter) => (
                            <FilterTag filter={removeCreatonStringFromEventLocationFilter(category.name, filter)}
                                       key={filter.uid}/>
                        ))}
                    </div>
                ))}
                {getResetFilter()}
            </div>
        </div>
    )
}

export default Filters
